import { MatSelect } from '@angular/material/select';

export abstract class MultiComboEntitySearchBase {
  abstract mySelect: MatSelect;
  abstract close(): void;
}
